let running = 0;
let canRun = 1;

const state = {
  queue: [],
};

const mutations = {
  GET_QUEUE(state) {
    return state.queue;
  },

  SET_QUEUE(state, exec) {
    state.queue = [exec, ...state.queue];
  },

  REMOVE_FROM_QUEUE(state, idx) {
    state.queue = state.queue.filter((x, i) => i !== idx);
  },
};

const actions = {
  getQueue({ commit }) {
    commit("GET_QUEUE");
  },

  setQueue({ commit }, exec) {
    exec.status = "PENDING";
    exec.response = {};
    exec.status = "AWAITING";
    commit("SET_QUEUE", exec);
    requeue();
  },

  removeFromQueue({ commit }, idx) {
    commit("REMOVE_FROM_QUEUE", idx);
  },
};

const requeue = () => {
  const qtd = canRun - running;
  state.queue
    .filter((x) => x.status === "AWAITING")
    .reverse()
    .slice(0, qtd)
    .forEach((exec) => {
      running++;
      exec.status = "PENDING";
      exec
        .fn(...exec.params)
        .then((response) => {
          running--;
          exec.status = "SUCCESS";
          exec.response = response;
          if (exec.afterSuccess) {
            exec.afterSuccess();
          }
          requeue();
        })
        .catch((err) => {
          running--;
          exec.status = "ERROR";
          exec.response = err;
          requeue();
          console.error(err);
        });
    });
};

const getters = {
  getQueue: (state) => state.queue,
};

const module = {
  state,
  mutations,
  actions,
  getters,
};

export default module;
